<template>
  <div class="container-fluid" v-if="$userIsAdmin">
    <div v-if="$userIsGlobalAdmin && regionOptions.length > 1" class="row">
      <h2>Filters</h2>
      <div class="col-sm-6 col-md-4" v-if="!$vlastMode">
        <div class="form-group">
          <label>Region</label>
          <selectize
            @input="getFilteredData"
            ref="regions"
            class="selectize selectize-single"
            name="region"
            v-model="selectedRegion"
            placeholder="Region"
            :options="regionOptions"/>
        </div>
      </div>
      <div class="col-sm-6 col-md-4" v-if="$vlastMode && $showDepartmentField">
        <div class="form-group">
          <label>Departments</label>
          <selectize
            @input="getFilteredData"
            name="departmentId"
            class="selectize selectize-single"
            v-model="departmentId"
            :pre-load="true"
            :fetch-results="getDepartmentIdOptions"
            :fetch-more-results="getMoreDepartmentIdOptions"
            :options="this.departmentOptions"/>
        </div>
      </div>
      <div class="col-sm-6 col-md-4" v-if="$vlastMode && $showCategoryStats">
        <div class="form-group">
          <label>Categories</label>
          <selectize
            @input="getFilteredData"
            name="categoryId"
            class="selectize selectize-single"
            v-model="categoryId"
            :pre-load="true"
            :fetch-results="getCategoryIdOptions"
            :fetch-more-results="getMoreCategoryIdOptions"
            :options="this.categoryOptions"/>
        </div>
      </div>
      <div class="col-sm-6 col-md-4" v-if="$vlastMode">
        <div class="form-group">
          <label>Organisations</label>
          <selectize
            @input="getFilteredData"
            name="organisationName"
            class="selectize selectize-single"
            v-model="organisationName"
            :pre-load="true"
            :fetch-results="getOrganisationNameOptions"
            :fetch-more-results="getMoreOrganisationNameOptions"
            :options="this.organisationOptions"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <h2>Weekly Activity</h2>

      <MetricCard
        v-if="metrics"
        v-for="(metric, key) in metrics"
        :metric="metric"
        :key="key"
        style-options="col-xs-12 col-sm-6 col-md-6"
      >
      </MetricCard>

      </div>

      <div class="col-sm-6">
        <h2>Annual Booking Count</h2>

        <MetricCard
          v-for="(metric, key) in annual"
          :metric="metric"
          :key="key"
          style-options="col-xs-12 col-sm-6 col-md-6"
        >
        </MetricCard>
      </div>
    </div>

    <div class="row">
    <div class="col-sm-12">
      <h2>User Activity</h2>
    </div>
    <div class="col-xs-12 col-sm-6">
        <datetime-line-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="star_signups"
          type="single"
          :showBrush="false"
          :chartOpenByDefault="true"
          :channelData="false"
          :name="$options.filters.sentenceCase($starLabel) + ' Signups'">
        </datetime-line-chart>
      </div>
      <div class="col-xs-12 col-sm-6">
        <datetime-line-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="client_signups"
          type="single"
          :showBrush="false"
          :chartOpenByDefault="true"
          :channelData="false"
          :name="$activeClientModuleEnabled ? this.$t('Client') + ' Signups' : this.$t('Clients') + ' Created'">
        </datetime-line-chart>
      </div>
      <div class="col-xs-12 col-sm-6">
        <datetime-line-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="manager_signups"
          type="single"
          :showBrush="false"
          :chartOpenByDefault="true"
          :channelData="false"
          name="Manager Signups">
        </datetime-line-chart>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <h2>Additional Charts</h2>
      </div>

      <div class="col-xs-12" v-if="$vlastMode && $showDepartmentField">
        <scatterplot
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          :showBrush="true"
          uniqueName="total_hours_per_player"
          :name="'hours_booked_per_' + $starLabel">
        </scatterplot>
      </div>
      <div class="col-xs-12" v-if="$vlastMode && $showDepartmentField">
        <bar-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          :showBrush="false"
          uniqueName="booking_request_by_opportunity_type"
          :name="$t('requests') + '_by_summary'">
        </bar-chart>
      </div>
      <div class="col-xs-12" v-if="$vlastMode && $showStateStats">
        <bar-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="completed_booking_requests_by_state"
          :showBrush="false"
          :name="'completed_' + $t('requests') + '_by_state'">
        </bar-chart>
      </div>
      <div class="col-xs-12" v-if="$vlastMode && $showStateStats">
        <bar-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="budget_per_state"
          :showBrush="false"
          name="committed_booking_budget_per_state">
        </bar-chart>
      </div>
      <div class="col-xs-12" v-if="$vlastMode && $showStateStats">
        <grouped-bar-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="completed_booking_requests_by_state_by_category"
          :showBrush="false"
          :name="'completed_' + $t('requests') + '_by_state_by_category'">
        </grouped-bar-chart>
      </div>
      <div class="col-xs-12" v-if="$vlastMode && $showDepartmentField">
        <bar-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="budget_by_player"
          :showBrush="false"
          :name="'budget_by_' + $starLabel">
        </bar-chart>
      </div>
      <div class="col-xs-12" v-if="$vlastMode && $showDepartmentField">
        <bar-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="pending_requests_by_player"
          :showBrush="false"
          :name="'pending_' + $t('requests') + '_by_' + $starLabel">
        </bar-chart>
      </div>
      <div class="col-xs-12" v-if="$vlastMode && $showDepartmentField">
        <bar-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="total_hours_per_department"
          :showBrush="false"
          name="hours_per_department">
        </bar-chart>
      </div>
      <div class="col-xs-12" v-if="$vlastMode && $showDepartmentField">
        <bar-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="booking_request_by_department"
          :showBrush="false"
          :name="$t('requests') + '_by_department'">
        </bar-chart>
      </div>
      <div class="col-xs-12" v-if="$vlastMode && $showDepartmentField">
        <grouped-bar-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="booking_request_by_player_by_category"
          :showBrush="false"
          :name="$t('requests') + '_by_' + $starLabel + '_by_category'">
        </grouped-bar-chart>
      </div>
      <div class="col-xs-12" v-if="$vlastMode && $showDepartmentField">
        <grouped-bar-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="booking_total_budget_by_player_by_category"
          :showBrush="false"
          :name="'booking_total_budget_by_' + $starLabel + '_by_category'">
        </grouped-bar-chart>
      </div>
      <div v-if="$vlastMode && $showDepartmentField" class="col-xs-12">
        <datetime-line-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="completed"
          type="single"
          :showBrush="false"
          :channelData="false"
          name="completed">
        </datetime-line-chart>
      </div>
      <div class="col-xs-12" v-if="!$vlastMode">
        <datetime-line-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="leads"
          type="single"
          :showBrush="false"
          :channelData="false"
          name="leads">
        </datetime-line-chart>
      </div>
      <div class="col-xs-12" v-if="!$vlastMode">
        <datetime-line-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="requests"
          type="single"
          :showBrush="false"
          :channelData="false"
          :name="$t('requests')">
        </datetime-line-chart>
      </div>
      <div class="col-xs-12" v-if="$paymentsModuleEnabled">
        <datetime-line-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="invoices"
          type="single"
          :showBrush="false"
          :channelData="false"
          name="invoices">
        </datetime-line-chart>
      </div>
      <div class="col-xs-12" v-if="$vlastMode">
        <div class="col-sm-12">
          <h2>Opportunity Type Breakdown</h2>
        </div>
        <options-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          :options="[
                     {
                     'type': 'multi',
                     'showBrush': true,
                     'name': 'In Person',
                     'uniqueName': 'requests_by_type',
                     'height': 280
                     },
                     {
                     'type': 'multi',
                     'showBrush': true,
                     'name': 'Online',
                     'uniqueName': 'online_requests_by_type',
                     'height': 280
                     }
                    ]">
        </options-chart>
      </div>
      <div v-else>
        <div class="col-sm-12">
          <h2>Channel Breakdown</h2>
        </div>
        <options-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          :options="[
                     {
                     'type': 'multi',
                     'showBrush': true,
                     'name': 'Leads by channel',
                     'height': 280,
                     'uniqueName': 'leads_by_channel'
                     },
                     {
                     'type': 'multi',
                     'showBrush': true,
                     'name': $t('Requests') + ' by channel',
                     'height': 280,
                     'uniqueName': 'requests_by_channel'
                     },
                     {
                     'type': 'multi',
                     'showBrush': true,
                     'name': 'Invoices by channel',
                     'height': 280,
                     'uniqueName': 'invoices_by_channel'
                     }
                    ]">
        </options-chart>
      </div>
    </div>
  </div>
  <div class="container-fluid" v-else-if="$userIsClient && $vlastMode && $showClientBIBudgetPerStateEnabled">
    <div class="row">
      <div class="col-sm-12">
          <h2>User Activity</h2>
        </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <bar-chart
          :key="JSON.stringify(this.prevParams)"
          :filterParams="this.prevParams"
          class="chart-card"
          uniqueName="budget_per_state"
          :showBrush="false"
          :chartOpenByDefault="true"
          :channelData="false"
          :isChartOpen="true"
          name="committed_booking_budget_per_state">
        </bar-chart>
      </div>
    </div>
  </div>
</template>

<script>
import DatetimeLineChart from './DatetimeLineChart'
import Scatterplot from './Scatterplot'
import OptionsChart from './OptionsChart'
import MetricCard from './MetricCard'
import BarChart from './BarChart'
import GroupedBarChart from './GroupedBarChart'
import VueApexCharts from 'vue-apexcharts'
import Vue from 'vue'
import Selectize from '../ext/codium/CodiumSelectize'
import { mapActions, mapState } from 'vuex'
import { map, isEqual } from 'lodash'
import { http } from 'utils'

Vue.component('apexchart', VueApexCharts)

export default {
  components: {DatetimeLineChart, MetricCard, OptionsChart, Selectize, BarChart, Scatterplot, GroupedBarChart},

  computed: {
    ...mapState('businessintelligence', ['metrics', 'annual'])
  },

  methods: {
    ...mapActions('businessintelligence', ['getMetrics', 'getAnnual']),
    ...mapActions('region', ['getRegions']),
    getFilteredData () {
      const params = {
        ...this.selectedRegion && {regionId: this.selectedRegion},
        ...this.departmentId && {departmentId: this.departmentId},
        ...this.categoryId && {categoryId: this.categoryId},
        ...this.organisationName && {organisationName: this.organisationName}
      }

      if (isEqual(params, this.prevParams)) {
        return false
      }

      this.prevParams = params
      this.getMetrics(params)
      this.getAnnual(params)
    },

    organisationNameOptionSetter (response) {
      if (response.data.data) {
        this.organisationOptions = this.organisationOptions.concat(map(response.data.data, organisation => ({id: organisation.company, text: organisation.company})))
        this.organisationMeta = response.data.meta
      }
    },

    getOrganisationNameOptions () {
      this.getFilterOptions('user/company', {}, this.organisationNameOptionSetter)
    },

    getMoreOrganisationNameOptions (name, callback) {
      if (this.organisationMeta.current_page < this.organisationMeta.last_page) {
        this.getFilterOptions('user/company', {page: this.organisationMeta.current_page + 1}, this.organisationNameOptionSetter).then(() => {
          callback(this.organisationOptions)
        })
      }
      return Promise.resolve()
    },

    departmentIdOptionSetter (response) {
      if (response.data.data) {
        this.departmentOptions = this.departmentOptions.concat(map(response.data.data, department => ({id: department.id, text: department.name})))
        this.departmentMeta = response.data.meta
      }
    },

    getDepartmentIdOptions () {
      this.getFilterOptions('departments', {}, this.departmentIdOptionSetter)
    },

    getMoreDepartmentIdOptions (name, callback) {
      if (this.departmentMeta.current_page < this.departmentMeta.last_page) {
        this.getFilterOptions('departments', {page: this.departmentMeta.current_page + 1}, this.departmentIdOptionSetter).then(() => {
          callback(this.departmentOptions)
        })
      }
      return Promise.resolve()
    },

    categoryIdOptionSetter (response) {
      if (response.data.data) {
        this.categoryOptions = this.categoryOptions.concat(map(response.data.data, category => ({id: category.id, text: category.name})))
        this.categoryMeta = response.data.meta
      }
    },

    getCategoryIdOptions () {
      this.getFilterOptions('categories', {page: 1}, this.categoryIdOptionSetter)
    },

    getMoreCategoryIdOptions (name, callback) {
      if (this.categoryMeta.current_page < this.categoryMeta.last_page) {
        this.getFilterOptions('categories', {page: this.categoryMeta.current_page + 1}, this.categoryIdOptionSetter).then(() => {
          callback(this.categoryOptions)
        })
      }
      return Promise.resolve()
    },

    getFilterOptions (endpoint, filter, callback) {
      return http.get(endpoint, { params: filter }).then(response => {
        callback(response)
      })
    }
  },

  created () {
    this.getFilteredData()
    this.getRegions()
      .then((response) => {
        this.regionOptions = map(response.data, region => ({ id: region.id, text: region.name })).concat({ id: 0, text: 'None' })
        this.selectedRegion = this.$user.region_id
      })
  },

  data () {
    return {
      regionOptions: [],
      departmentOptions: [{id: 0, text: 'All'}],
      organisationOptions: [{ id: 0, text: 'All' }],
      categoryOptions: [{ id: 0, text: 'All' }],
      departmentId: 0,
      categoryId: 0,
      organisationName: 0,
      organisationMeta: null,
      categoryMeta: null,
      departmentMeta: null,
      selectedRegion: null,
      prevParams: null,
      chartOptions: {
        chart: {
          type: 'line',
          zoom: {
            type: 'xy'
          }
        },
        xaxis: {
          type: 'datetime'
        }
      }
    }
  }
}
</script>

<style>
.expand-enter-active,
.expand-leave-active {
  transition: max-height 1s ease;
  max-height: 500px;
}

.expand-enter,
.expand-leave-to {
  max-height: 0;
  overflow: hidden;
}
</style>
